import PageTransitionLoading from "@/components/PageTransitionLoading";
import { useDeviceInfoQuery, usePreventContextMenu } from "@/hooks";
import Footer from "@/layouts/footer";
import Header from "@/layouts/Header";
import { useRouter } from "next/router";
import { isWebViewReact } from "@/apollo/reactives";

export function Layout({ children, noHeader, noTransition }) {
  usePreventContextMenu();
  const router = useRouter();
  const { data: { deviceInfo } = {} } = useDeviceInfoQuery();
  const isTvApp = router?.asPath?.includes("/tvapp/static");
  const visible = !isWebViewReact() && !isTvApp;
  return (
    <>
      <PageTransitionLoading />
      {visible && <Header noHeader={noHeader} noTransition={noTransition} />}
      <main id="main" tabIndex={-1}>
        {children}
      </main>
      {visible && <Footer />}
    </>
  );
}
